import React, { Component } from 'react'
import { Loading } from '@myxplor/ui'
import { send, on } from '../../communication-bridge'


class AuthWithSessionToken extends Component {
  componentDidMount() {
    send('getSessionToken')
    on('sessionToken', (sessionToken) => this.props.sendSessionToken(sessionToken))
  }

  render() {
    return (
      <Loading>Authorising</Loading>
    )
  }
}

export default AuthWithSessionToken



// WEBPACK FOOTER //
// ./src/authorisation/with-session-token/index.jsx